/**
 * Admin Layout Template
 *
 * Layout base para todas as páginas do admin
 */
import React from 'react'
import { Outlet } from 'react-router-dom'
import Sidebar from '../organisms/Sidebar'
import { useAdminStore } from '../../core/admin.store'
import { useAdminGuard } from '../../core/admin.hooks'
import { LoadingScreen } from '../atoms/Spinner'

export default function AdminLayout() {
	const { sidebarOpen } = useAdminStore()
	const { checking } = useAdminGuard()

	if (checking) {
		return (
			<div className="h-screen">
				<LoadingScreen message="Verificando autenticação..." />
			</div>
		)
	}

	return (
		<div className="min-h-screen h-screen bg-base-100">
			<Sidebar />
			<main
				className={`
          min-h-screen transition-all duration-300 ease-in-out
          ${sidebarOpen ? 'ml-64' : 'ml-20'}
        `}
			>
				<Outlet />
			</main>
		</div>
	)
}
